import { useCalls, useEthers } from '@usedapp/core';
import { BigNumber } from 'ethers';

import { getStakingContract } from '../../../helpers/web3';

import versePolygonStakingData from '../../../data/verseStakingPolygonData';

export function useEarnPolBalance(): BigNumber {
  const { account } = useEthers();

  const calls = [
    {
      contract: getStakingContract(versePolygonStakingData.contractAddress),
      method: 'balanceOf',
      args: [account],
    },
  ];

  const results = useCalls(calls, { chainId: 137 }) ?? [];
  const polBalance = results[0]?.value?.[0] ?? BigNumber.from(0);

  return polBalance;
}
